// useDashboardData.js
import { useEffect, useState } from "react";
import { contarProductos } from "../../../../core/productos/infraestructure/supabase/productosPrecio.repository.js";




export function useDashboardData() {
  const [stats, setStats] = useState({
    productos: 0,
    facturas: 0,
    gastos: 0,
    promedio: [],
    loading: true,
  });
useEffect(() => {
  async function cargarDatos() {
    try {
      const [productos, facturas, gastosObj,pagosObj, promedio] = await Promise.all([
        contarProductos(),
   


      ]);

      const gastos = gastosObj.success ? gastosObj.total : 0;
      const pagos = pagosObj.success ? pagosObj.total : 0; // si quieres usarlo

      setStats({
        productos,
        facturas,
        gastos,
        pagos: Number(pagos) || 0, // garantiza que sea número
        promedio,
        loading: false,
      });
    } catch (error) {
      console.error("Dashboard error:", error);
      setStats((s) => ({ ...s, loading: false }));
    }
  }

  cargarDatos();
}, []);

  return stats;
}
